export const generatedScenarioCrossoverFrontierLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-scenario-crossover-frontier-ledger",
  "operatingRule": "Crossover frontiers expose how scenario rankings could change under explicit utility-formula deltas. They are sensitivity heuristics, not validation or investment advice.",
  "commercialUseAllowed": false,
  "leaderScenarioId": "moon-first",
  "leaderUtility": 67.12,
  "challengerCount": 5,
  "pairwiseComparisonCount": 30,
  "utilityFormula": "utility = clamp(50 + (weightedBenefitScore - weightedRiskScore) * 0.62 - uncertaintyPenalty * 0.42)",
  "weights": {
    "benefits": {
      "energy": 1,
      "vacuum": 0.75,
      "optionality": 1,
      "processFit": 1,
      "resourceConfidence": 1
    },
    "risks": {
      "transport": 1,
      "thermal": 0.9,
      "comms": 0.8,
      "feedstock": 1,
      "processMaturity": 0.8
    }
  },
  "evidenceHashes": {
    "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
    "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
  },
  "nearestCrossover": {
    "id": "crossover-hybrid-over-moon-first",
    "challengerScenarioId": "hybrid",
    "challengerName": "Hybrid Moon -> Asteroid -> Mercury",
    "currentLeaderScenarioId": "moon-first",
    "currentLeaderName": "Moon-first Bootstrap",
    "generatedAt": "2026-06-19T00:00:00.000Z",
    "currentRank": 2,
    "leaderUtility": 67.12,
    "challengerUtility": 65.69,
    "requiredUtilityDelta": 1.43,
    "crossoverState": "mathematically-reachable-not-validated",
    "topSingleLeverPaths": [
      {
        "kind": "uncertainty-reduction",
        "criterion": "uncertaintyPenalty",
        "currentValue": 12,
        "direction": "decrease",
        "utilityPerPoint": 0.42,
        "requiredRawDelta": 3.4,
        "feasibleByRawRange": true,
        "headroom": 12
      },
      {
        "kind": "risk-reduction",
        "criterion": "transport",
        "currentValue": 46,
        "direction": "decrease",
        "utilityPerPoint": 0.1378,
        "requiredRawDelta": 10.38,
        "feasibleByRawRange": true,
        "headroom": 46
      },
      {
        "kind": "risk-reduction",
        "criterion": "feedstock",
        "currentValue": 55,
        "direction": "decrease",
        "utilityPerPoint": 0.1378,
        "requiredRawDelta": 10.38,
        "feasibleByRawRange": true,
        "headroom": 55
      },
      {
        "kind": "benefit-increase",
        "criterion": "energy",
        "currentValue": 82,
        "direction": "increase",
        "utilityPerPoint": 0.1305,
        "requiredRawDelta": 10.96,
        "feasibleByRawRange": true,
        "headroom": 18
      },
      {
        "kind": "benefit-increase",
        "criterion": "processFit",
        "currentValue": 82,
        "direction": "increase",
        "utilityPerPoint": 0.1305,
        "requiredRawDelta": 10.96,
        "feasibleByRawRange": true,
        "headroom": 18
      },
      {
        "kind": "benefit-increase",
        "criterion": "resourceConfidence",
        "currentValue": 68,
        "direction": "increase",
        "utilityPerPoint": 0.1305,
        "requiredRawDelta": 10.96,
        "feasibleByRawRange": true,
        "headroom": 32
      }
    ],
    "blendedPath": {
      "mode": "equal-raw-delta-across-top-feasible-levers",
      "feasible": true,
      "rawDeltaEach": 2.06,
      "expectedUtilityDelta": 1.43,
      "levers": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "direction": "decrease",
          "rawDelta": 2.06,
          "utilityContribution": 0.87
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "direction": "decrease",
          "rawDelta": 2.06,
          "utilityContribution": 0.28
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "direction": "decrease",
          "rawDelta": 2.06,
          "utilityContribution": 0.28
        }
      ]
    },
    "economicsContext": {
      "businessReadinessMedian": 72.59,
      "winProbabilityPercent": 24.22,
      "medianCapitalGapBn": 0,
      "underfundedProbabilityPercent": 0.39
    },
    "assumptionLinks": [
      {
        "assumptionId": "assumption-resource-composition-unknown",
        "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
        "reviewState": "blocked-for-business-proof",
        "promotionAllowed": false,
        "utilityDelta": -0.86,
        "rankDelta": 0
      },
      {
        "assumptionId": "assumption-snapshot-first",
        "title": "Browser consumes reviewed snapshots first",
        "reviewState": "reviewable",
        "promotionAllowed": true,
        "utilityDelta": -0.21,
        "rankDelta": 0
      },
      {
        "assumptionId": "assumption-no-mercury-first",
        "title": "Mercury cannot be hardcoded as the winning scenario",
        "reviewState": "reviewable",
        "promotionAllowed": true,
        "utilityDelta": 0.16,
        "rankDelta": 0
      },
      {
        "assumptionId": "assumption-social-signals-market-only",
        "title": "Forums and social platforms are market signals, not science evidence",
        "reviewState": "blocked-for-business-proof",
        "promotionAllowed": false,
        "utilityDelta": -0.07,
        "rankDelta": 0
      },
      {
        "assumptionId": "assumption-launch-cost-ranges",
        "title": "Launch economics must use dated ranges and sensitivity bands",
        "reviewState": "blocked-for-business-proof",
        "promotionAllowed": false,
        "utilityDelta": -0.07,
        "rankDelta": 0
      }
    ],
    "decisionContext": {
      "decisionLane": "lane-3-watchlist",
      "decisionReadinessScore": 59.78,
      "promotionState": "blocked-for-commercial-proof",
      "blockerCount": 6,
      "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
    },
    "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
    "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
  },
  "crossovers": [
    {
      "id": "crossover-hybrid-over-moon-first",
      "challengerScenarioId": "hybrid",
      "challengerName": "Hybrid Moon -> Asteroid -> Mercury",
      "currentLeaderScenarioId": "moon-first",
      "currentLeaderName": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "currentRank": 2,
      "leaderUtility": 67.12,
      "challengerUtility": 65.69,
      "requiredUtilityDelta": 1.43,
      "crossoverState": "mathematically-reachable-not-validated",
      "topSingleLeverPaths": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "currentValue": 12,
          "direction": "decrease",
          "utilityPerPoint": 0.42,
          "requiredRawDelta": 3.4,
          "feasibleByRawRange": true,
          "headroom": 12
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "currentValue": 46,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 10.38,
          "feasibleByRawRange": true,
          "headroom": 46
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "currentValue": 55,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 10.38,
          "feasibleByRawRange": true,
          "headroom": 55
        },
        {
          "kind": "benefit-increase",
          "criterion": "energy",
          "currentValue": 82,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 10.96,
          "feasibleByRawRange": true,
          "headroom": 18
        },
        {
          "kind": "benefit-increase",
          "criterion": "processFit",
          "currentValue": 82,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 10.96,
          "feasibleByRawRange": true,
          "headroom": 18
        },
        {
          "kind": "benefit-increase",
          "criterion": "resourceConfidence",
          "currentValue": 68,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 10.96,
          "feasibleByRawRange": true,
          "headroom": 32
        }
      ],
      "blendedPath": {
        "mode": "equal-raw-delta-across-top-feasible-levers",
        "feasible": true,
        "rawDeltaEach": 2.06,
        "expectedUtilityDelta": 1.43,
        "levers": [
          {
            "kind": "uncertainty-reduction",
            "criterion": "uncertaintyPenalty",
            "direction": "decrease",
            "rawDelta": 2.06,
            "utilityContribution": 0.87
          },
          {
            "kind": "risk-reduction",
            "criterion": "transport",
            "direction": "decrease",
            "rawDelta": 2.06,
            "utilityContribution": 0.28
          },
          {
            "kind": "risk-reduction",
            "criterion": "feedstock",
            "direction": "decrease",
            "rawDelta": 2.06,
            "utilityContribution": 0.28
          }
        ]
      },
      "economicsContext": {
        "businessReadinessMedian": 72.59,
        "winProbabilityPercent": 24.22,
        "medianCapitalGapBn": 0,
        "underfundedProbabilityPercent": 0.39
      },
      "assumptionLinks": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.86,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.21,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.16,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.07,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.07,
          "rankDelta": 0
        }
      ],
      "decisionContext": {
        "decisionLane": "lane-3-watchlist",
        "decisionReadinessScore": 59.78,
        "promotionState": "blocked-for-commercial-proof",
        "blockerCount": 6,
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
      },
      "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
      "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
    },
    {
      "id": "crossover-asteroid-first-over-moon-first",
      "challengerScenarioId": "asteroid-first",
      "challengerName": "Asteroid Feedstock-first",
      "currentLeaderScenarioId": "moon-first",
      "currentLeaderName": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "currentRank": 3,
      "leaderUtility": 67.12,
      "challengerUtility": 51.37,
      "requiredUtilityDelta": 15.75,
      "crossoverState": "outside-single-lever-range",
      "topSingleLeverPaths": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "currentValue": 18,
          "direction": "decrease",
          "utilityPerPoint": 0.42,
          "requiredRawDelta": 37.5,
          "feasibleByRawRange": false,
          "headroom": 18
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "currentValue": 58,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 114.31,
          "feasibleByRawRange": false,
          "headroom": 58
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "currentValue": 72,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 114.31,
          "feasibleByRawRange": false,
          "headroom": 72
        },
        {
          "kind": "benefit-increase",
          "criterion": "energy",
          "currentValue": 61,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 120.67,
          "feasibleByRawRange": false,
          "headroom": 39
        },
        {
          "kind": "benefit-increase",
          "criterion": "optionality",
          "currentValue": 84,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 120.67,
          "feasibleByRawRange": false,
          "headroom": 16
        },
        {
          "kind": "benefit-increase",
          "criterion": "processFit",
          "currentValue": 75,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 120.67,
          "feasibleByRawRange": false,
          "headroom": 25
        }
      ],
      "blendedPath": {
        "mode": "equal-raw-delta-across-top-feasible-levers",
        "feasible": false,
        "rawDeltaEach": null,
        "expectedUtilityDelta": 0,
        "levers": []
      },
      "economicsContext": {
        "businessReadinessMedian": 59.76,
        "winProbabilityPercent": 0,
        "medianCapitalGapBn": 0,
        "underfundedProbabilityPercent": 2.73
      },
      "assumptionLinks": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -1.68,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.46,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.39,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.09,
          "rankDelta": 0
        }
      ],
      "decisionContext": {
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.63,
        "promotionState": "blocked-for-commercial-proof",
        "blockerCount": 7,
        "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
      },
      "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
      "crossoverHash": "sha256-14d2ba998f0843e1cdd3b05e6b5d598c9fb1800b385852c58702ed5ca16e6451"
    },
    {
      "id": "crossover-mercury-orbit-over-moon-first",
      "challengerScenarioId": "mercury-orbit",
      "challengerName": "Mercury Orbit-first",
      "currentLeaderScenarioId": "moon-first",
      "currentLeaderName": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "currentRank": 4,
      "leaderUtility": 67.12,
      "challengerUtility": 42.95,
      "requiredUtilityDelta": 24.17,
      "crossoverState": "outside-single-lever-range",
      "topSingleLeverPaths": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "currentValue": 24,
          "direction": "decrease",
          "utilityPerPoint": 0.42,
          "requiredRawDelta": 57.55,
          "feasibleByRawRange": false,
          "headroom": 24
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "currentValue": 86,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 175.43,
          "feasibleByRawRange": false,
          "headroom": 86
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "currentValue": 70,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 175.43,
          "feasibleByRawRange": false,
          "headroom": 70
        },
        {
          "kind": "benefit-increase",
          "criterion": "energy",
          "currentValue": 97,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 185.17,
          "feasibleByRawRange": false,
          "headroom": 3
        },
        {
          "kind": "benefit-increase",
          "criterion": "optionality",
          "currentValue": 86,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 185.17,
          "feasibleByRawRange": false,
          "headroom": 14
        },
        {
          "kind": "benefit-increase",
          "criterion": "processFit",
          "currentValue": 84,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 185.17,
          "feasibleByRawRange": false,
          "headroom": 16
        }
      ],
      "blendedPath": {
        "mode": "equal-raw-delta-across-top-feasible-levers",
        "feasible": false,
        "rawDeltaEach": null,
        "expectedUtilityDelta": 0,
        "levers": []
      },
      "economicsContext": {
        "businessReadinessMedian": 55.33,
        "winProbabilityPercent": 0,
        "medianCapitalGapBn": 0,
        "underfundedProbabilityPercent": 10.94
      },
      "assumptionLinks": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.82,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.67,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.28,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.04,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": 0.03,
          "rankDelta": 0
        }
      ],
      "decisionContext": {
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 44.15,
        "promotionState": "blocked-for-commercial-proof",
        "blockerCount": 7,
        "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
      },
      "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
      "crossoverHash": "sha256-f940f38796bd99b5bea066e98097804da86a30d687c323e182571126dc7f0531"
    },
    {
      "id": "crossover-mars-first-over-moon-first",
      "challengerScenarioId": "mars-first",
      "challengerName": "Mars-first Conventional Expansion",
      "currentLeaderScenarioId": "moon-first",
      "currentLeaderName": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "currentRank": 5,
      "leaderUtility": 67.12,
      "challengerUtility": 40.78,
      "requiredUtilityDelta": 26.34,
      "crossoverState": "outside-single-lever-range",
      "topSingleLeverPaths": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "currentValue": 12,
          "direction": "decrease",
          "utilityPerPoint": 0.42,
          "requiredRawDelta": 62.71,
          "feasibleByRawRange": false,
          "headroom": 12
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "currentValue": 62,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 191.18,
          "feasibleByRawRange": false,
          "headroom": 62
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "currentValue": 48,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 191.18,
          "feasibleByRawRange": false,
          "headroom": 48
        },
        {
          "kind": "benefit-increase",
          "criterion": "energy",
          "currentValue": 36,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 201.8,
          "feasibleByRawRange": false,
          "headroom": 64
        },
        {
          "kind": "benefit-increase",
          "criterion": "optionality",
          "currentValue": 65,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 201.8,
          "feasibleByRawRange": false,
          "headroom": 35
        },
        {
          "kind": "benefit-increase",
          "criterion": "processFit",
          "currentValue": 46,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 201.8,
          "feasibleByRawRange": false,
          "headroom": 54
        }
      ],
      "blendedPath": {
        "mode": "equal-raw-delta-across-top-feasible-levers",
        "feasible": false,
        "rawDeltaEach": null,
        "expectedUtilityDelta": 0,
        "levers": []
      },
      "economicsContext": {
        "businessReadinessMedian": 63.22,
        "winProbabilityPercent": 0,
        "medianCapitalGapBn": 0,
        "underfundedProbabilityPercent": 1.95
      },
      "assumptionLinks": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.33,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.06,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.05,
          "rankDelta": 0
        }
      ],
      "decisionContext": {
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.72,
        "promotionState": "blocked-for-commercial-proof",
        "blockerCount": 5,
        "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb"
      },
      "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
      "crossoverHash": "sha256-10c3e7b172c2d8ee3f3d88aea2ae3824e3325b1901205a9de783e5f4b62c146a"
    },
    {
      "id": "crossover-mercury-polar-over-moon-first",
      "challengerScenarioId": "mercury-polar",
      "challengerName": "Mercury Polar Surface-first",
      "currentLeaderScenarioId": "moon-first",
      "currentLeaderName": "Moon-first Bootstrap",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "currentRank": 6,
      "leaderUtility": 67.12,
      "challengerUtility": 37.95,
      "requiredUtilityDelta": 29.17,
      "crossoverState": "outside-single-lever-range",
      "topSingleLeverPaths": [
        {
          "kind": "uncertainty-reduction",
          "criterion": "uncertaintyPenalty",
          "currentValue": 26,
          "direction": "decrease",
          "utilityPerPoint": 0.42,
          "requiredRawDelta": 69.45,
          "feasibleByRawRange": false,
          "headroom": 26
        },
        {
          "kind": "risk-reduction",
          "criterion": "transport",
          "currentValue": 90,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 211.72,
          "feasibleByRawRange": false,
          "headroom": 90
        },
        {
          "kind": "risk-reduction",
          "criterion": "feedstock",
          "currentValue": 64,
          "direction": "decrease",
          "utilityPerPoint": 0.1378,
          "requiredRawDelta": 211.72,
          "feasibleByRawRange": false,
          "headroom": 64
        },
        {
          "kind": "benefit-increase",
          "criterion": "energy",
          "currentValue": 88,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 223.48,
          "feasibleByRawRange": false,
          "headroom": 12
        },
        {
          "kind": "benefit-increase",
          "criterion": "optionality",
          "currentValue": 80,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 223.48,
          "feasibleByRawRange": false,
          "headroom": 20
        },
        {
          "kind": "benefit-increase",
          "criterion": "processFit",
          "currentValue": 74,
          "direction": "increase",
          "utilityPerPoint": 0.1305,
          "requiredRawDelta": 223.48,
          "feasibleByRawRange": false,
          "headroom": 26
        }
      ],
      "blendedPath": {
        "mode": "equal-raw-delta-across-top-feasible-levers",
        "feasible": false,
        "rawDeltaEach": null,
        "expectedUtilityDelta": 0,
        "levers": []
      },
      "economicsContext": {
        "businessReadinessMedian": 53.68,
        "winProbabilityPercent": 0,
        "medianCapitalGapBn": 0,
        "underfundedProbabilityPercent": 11.91
      },
      "assumptionLinks": [
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.63,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.45,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.17,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.04,
          "rankDelta": 0
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": 0.03,
          "rankDelta": 0
        }
      ],
      "decisionContext": {
        "decisionLane": "lane-4-research-backlog",
        "decisionReadinessScore": 41.42,
        "promotionState": "blocked-for-commercial-proof",
        "blockerCount": 7,
        "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934"
      },
      "evidenceBoundary": "Crossover paths are deterministic planner heuristics based on the current utility formula. They identify what would need to change; they do not prove that the change is physically, economically, or commercially achievable.",
      "crossoverHash": "sha256-0919818abda3f7c04f8c359aef7aeceb89e09cf8edaff76dceaa60fe8d08423b"
    }
  ],
  "pairwiseMatrix": [
    {
      "fromScenarioId": "moon-first",
      "toScenarioId": "hybrid",
      "utilityDelta": -1.43,
      "fromUtility": 67.12,
      "toUtility": 65.69,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "moon-first",
      "toScenarioId": "asteroid-first",
      "utilityDelta": -15.75,
      "fromUtility": 67.12,
      "toUtility": 51.37,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "moon-first",
      "toScenarioId": "mercury-orbit",
      "utilityDelta": -24.17,
      "fromUtility": 67.12,
      "toUtility": 42.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "moon-first",
      "toScenarioId": "mars-first",
      "utilityDelta": -26.34,
      "fromUtility": 67.12,
      "toUtility": 40.78,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "moon-first",
      "toScenarioId": "mercury-polar",
      "utilityDelta": -29.17,
      "fromUtility": 67.12,
      "toUtility": 37.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "hybrid",
      "toScenarioId": "moon-first",
      "utilityDelta": 1.43,
      "fromUtility": 65.69,
      "toUtility": 67.12,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "hybrid",
      "toScenarioId": "asteroid-first",
      "utilityDelta": -14.32,
      "fromUtility": 65.69,
      "toUtility": 51.37,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "hybrid",
      "toScenarioId": "mercury-orbit",
      "utilityDelta": -22.74,
      "fromUtility": 65.69,
      "toUtility": 42.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "hybrid",
      "toScenarioId": "mars-first",
      "utilityDelta": -24.91,
      "fromUtility": 65.69,
      "toUtility": 40.78,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "hybrid",
      "toScenarioId": "mercury-polar",
      "utilityDelta": -27.74,
      "fromUtility": 65.69,
      "toUtility": 37.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "asteroid-first",
      "toScenarioId": "moon-first",
      "utilityDelta": 15.75,
      "fromUtility": 51.37,
      "toUtility": 67.12,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "asteroid-first",
      "toScenarioId": "hybrid",
      "utilityDelta": 14.32,
      "fromUtility": 51.37,
      "toUtility": 65.69,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "asteroid-first",
      "toScenarioId": "mercury-orbit",
      "utilityDelta": -8.42,
      "fromUtility": 51.37,
      "toUtility": 42.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "asteroid-first",
      "toScenarioId": "mars-first",
      "utilityDelta": -10.59,
      "fromUtility": 51.37,
      "toUtility": 40.78,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "asteroid-first",
      "toScenarioId": "mercury-polar",
      "utilityDelta": -13.42,
      "fromUtility": 51.37,
      "toUtility": 37.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "mercury-orbit",
      "toScenarioId": "moon-first",
      "utilityDelta": 24.17,
      "fromUtility": 42.95,
      "toUtility": 67.12,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-orbit",
      "toScenarioId": "hybrid",
      "utilityDelta": 22.74,
      "fromUtility": 42.95,
      "toUtility": 65.69,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-orbit",
      "toScenarioId": "asteroid-first",
      "utilityDelta": 8.42,
      "fromUtility": 42.95,
      "toUtility": 51.37,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-orbit",
      "toScenarioId": "mars-first",
      "utilityDelta": -2.17,
      "fromUtility": 42.95,
      "toUtility": 40.78,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "mercury-orbit",
      "toScenarioId": "mercury-polar",
      "utilityDelta": -5,
      "fromUtility": 42.95,
      "toUtility": 37.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "mars-first",
      "toScenarioId": "moon-first",
      "utilityDelta": 26.34,
      "fromUtility": 40.78,
      "toUtility": 67.12,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mars-first",
      "toScenarioId": "hybrid",
      "utilityDelta": 24.91,
      "fromUtility": 40.78,
      "toUtility": 65.69,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mars-first",
      "toScenarioId": "asteroid-first",
      "utilityDelta": 10.59,
      "fromUtility": 40.78,
      "toUtility": 51.37,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mars-first",
      "toScenarioId": "mercury-orbit",
      "utilityDelta": 2.17,
      "fromUtility": 40.78,
      "toUtility": 42.95,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mars-first",
      "toScenarioId": "mercury-polar",
      "utilityDelta": -2.83,
      "fromUtility": 40.78,
      "toUtility": 37.95,
      "toScenarioAlreadyWins": false
    },
    {
      "fromScenarioId": "mercury-polar",
      "toScenarioId": "moon-first",
      "utilityDelta": 29.17,
      "fromUtility": 37.95,
      "toUtility": 67.12,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-polar",
      "toScenarioId": "hybrid",
      "utilityDelta": 27.74,
      "fromUtility": 37.95,
      "toUtility": 65.69,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-polar",
      "toScenarioId": "asteroid-first",
      "utilityDelta": 13.42,
      "fromUtility": 37.95,
      "toUtility": 51.37,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-polar",
      "toScenarioId": "mercury-orbit",
      "utilityDelta": 5,
      "fromUtility": 37.95,
      "toUtility": 42.95,
      "toScenarioAlreadyWins": true
    },
    {
      "fromScenarioId": "mercury-polar",
      "toScenarioId": "mars-first",
      "utilityDelta": 2.83,
      "fromUtility": 37.95,
      "toUtility": 40.78,
      "toScenarioAlreadyWins": true
    }
  ],
  "ledgerHash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1"
}
;
